import React from "react";
import {IAssistantContext} from "../dependencies/interfaces/IAssistantContext";
import Spaces from "../../../../components/sharedComponents/Spaces";
import {ButtonBack} from "../../../../components/sharedComponents/Buttons/ButtonBack";

export default (props: IAssistantContext) => {
  
  const isButtonActive: boolean = !!props.form.contract;
  
  return (<section>
    
    <Spaces n={0}/>
    
    <div className={"assistant--v2-container--no-flex"}>
      <div className={"space-light"}>
        <ButtonBack back={() => props.wizard.previousStep()}/>
      </div>
    </div>
    
    <div className={"assistant--v2-title"}>
      Quel type de contrat ?
    </div>
    
    <Spaces n={1}/>
  
    <div className={"assistant--v2-container--no-flex text--center assistant--v2--appear"}>
    
      <input type={"text"} className={"assistant--v2-input"} name={"contract"}
             value={props.form.contract} onChange={props.updateForm({maximumLength: 40})}/>
    
      <Spaces n={1}/>
    
      <button className={"btn-assistant-main"}
              disabled={!isButtonActive}
              onClick={async() => {
                props.wizard.nextStep();
              }}>
        Suivant
      </button>
  
    </div>
  
  </section>);
}